import { render, staticRenderFns } from "./MainViewFrame.vue?vue&type=template&id=27f9f051&scoped=true&"
import script from "./MainViewFrame.vue?vue&type=script&lang=js&"
export * from "./MainViewFrame.vue?vue&type=script&lang=js&"
import style0 from "./MainViewFrame.vue?vue&type=style&index=0&id=27f9f051&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f9f051",
  null
  
)

export default component.exports